import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './BillsOfLading.slice'
import { paginate } from './BillsOfLading.thunk'

function paginateBillsOfLading () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateBillsOfLading),
    takeLatest(actions.replacePage, paginateBillsOfLading),
    takeLatest(actions.replaceSearch, paginateBillsOfLading)
  ])
}
